export default __webpack_public_path__ + "static/media/avatarB3.b7d35aea.png";